import { EmissionLabelsSeparators } from '../hooks/use-efficiency-labels-separators';

import { EnergyManagementType } from '../types';

import { WLTPRangeValue, WltpEnergyEfficiency } from '../../../services/victor/trim-layer-details-response';
import { createEfficiencyValueString, findVehicleEmissionData } from './index';

interface CreateHybridFueltypeProps {
	energyEfficiency: WltpEnergyEfficiency;
	wltpRangeValue: WLTPRangeValue[];
	emissionLabelsSeparators: EmissionLabelsSeparators;
}

export function createHybridFueltype({
	energyEfficiency,
	wltpRangeValue,
	emissionLabelsSeparators
}: CreateHybridFueltypeProps) {
	const efficiencyDataWeighted = findVehicleEmissionData(wltpRangeValue, EnergyManagementType.Weighted);
	const efficiencyDataSustaining = findVehicleEmissionData(wltpRangeValue, EnergyManagementType.Sustaining);

	// Emmission only exists once in weighted :)
	const emissionData = efficiencyDataWeighted.find(emissionElement => emissionElement.valueType === 'CO2');

	const efficiencyClassDataWeighted = energyEfficiency?.classWltp; // First instance of it for combustion
	const efficiencyClassDataSustaining = energyEfficiency?.classWltp2 || energyEfficiency?.classWltp; // Second instance of it for electric

	const consumptionDataWeighted = efficiencyDataWeighted.filter(
		emissionElement => emissionElement.valueType === 'CONSUMPTION'
	);
	const consumptionDataWeightedElectric = consumptionDataWeighted.find(item => item.fuelType === 'ELECTRICAL');
	const consumptionDataWeightedCombustion = consumptionDataWeighted.find(item => item.fuelType !== 'ELECTRICAL');

	// Sustaining is with battery empty
	const consumptionDataSustaining = efficiencyDataSustaining.find(
		emissionElement => emissionElement.valueType === 'CONSUMPTION'
	);

	if (
		!emissionData ||
		!consumptionDataWeightedCombustion ||
		!consumptionDataWeightedElectric ||
		!consumptionDataSustaining ||
		!efficiencyClassDataWeighted ||
		!efficiencyClassDataSustaining
	)
		return;

	const emissionsHybrid = createEfficiencyValueString(emissionData.value, emissionData.unit);

	const consumptionWeightedElectric = `${createEfficiencyValueString(
		consumptionDataWeightedElectric.value,
		consumptionDataWeightedElectric.unit
	)} `;
	const consumptionWeightedCombustion = `${createEfficiencyValueString(
		consumptionDataWeightedCombustion.value,
		consumptionDataWeightedCombustion.unit
	)}`;
	const consumptionSustainingCombustion = `${createEfficiencyValueString(
		consumptionDataSustaining.value,
		consumptionDataSustaining.unit
	)}`;
	const efficiencyClassHybridWeighted = `${createEfficiencyValueString(efficiencyClassDataWeighted)}`;
	const efficiencyClassHybridSustaining = efficiencyClassDataSustaining.max;

	const {
		energyConsumptionWeightedLabel,
		hybridValueSeparator,
		consumptionEmissionsSeparator,
		energyConsumptionSustainingLabel,
		emissionLabel,
		efficiencyClassWeightedLabel,
		efficiencyClassSustainingLabel
	} = emissionLabelsSeparators;

	return [
		energyConsumptionWeightedLabel,
		consumptionWeightedElectric,
		hybridValueSeparator,
		consumptionWeightedCombustion,
		consumptionEmissionsSeparator,
		energyConsumptionSustainingLabel,
		consumptionSustainingCombustion,
		consumptionEmissionsSeparator,
		emissionLabel,
		emissionsHybrid,
		consumptionEmissionsSeparator,
		efficiencyClassWeightedLabel,
		efficiencyClassHybridWeighted,
		consumptionEmissionsSeparator,
		efficiencyClassSustainingLabel,
		efficiencyClassHybridSustaining
	].join(' ');
}
